export { default } from './FFBEditor';
